import { useGlobalContext } from "../context/GlobalContext";
import footerImageLight from "../assets/images/footer_light.png";
import footerImageDark from "../assets/images/footer_dark.png";

export default function Footer() {
  const { darkMode } = useGlobalContext();

  return (
    <div className="flex flex-col text-lz-ink-mid dark:text-white">
      <img
        src={darkMode ? footerImageDark : footerImageLight}
        alt="Logo for the Grand Lodge of the English Language Jurisdiction of AMORC, Rosicrucian Order"
        className="w-full md:w-1/2 self-center !m-0"
      />
      <div className="text-center">
        <small>
          © 2026 The Supreme Grand Lodge of the Ancient & Mystical Order Rosae
          Crucis. All rights reserved.
          <br />
          <br />
          Published by The Grand Lodge of the English Language Jurisdiction of
          the Ancient and Mystical Order Rosae Crucis.
          <br />
          <br />
          This lesson is provided only to the member to whom it is issued,
          solely for that member's personal study and use. It remains the
          confidential and proprietary work of the Rosicrucian Order, AMORC. No
          part of this lesson may be copied, shared, posted, published,
          distributed, sold, transmitted, or used to create derivative works
          without AMORC's prior written permission. Unauthorized use may result
          in termination of membership and may subject the user to civil
          liability.
        </small>
      </div>
    </div>
  );
}
